import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Users, Target, Award } from 'lucide-react';

interface ScoutApplicationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ScoutApplicationModal: React.FC<ScoutApplicationModalProps> = ({
  open,
  onOpenChange
}) => {
  const navigate = useNavigate();

  const handleGoToAdmin = () => {
    onOpenChange(false);
    navigate('/admin-dashboard');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-heading">Join Our Scout Team!</DialogTitle>
          <DialogDescription className="pt-2">
            Thank you for your interest in becoming a RecruitLook Scout. To apply, please access our admin portal where you can submit your application and learn more about the requirements.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div className="p-3 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
              <Users className="w-8 h-8 text-secondary mx-auto mb-2" />
              <p className="text-xs font-semibold text-gray-700">Help Athletes</p>
            </div>
            <div className="p-3 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
              <Target className="w-8 h-8 text-secondary mx-auto mb-2" />
              <p className="text-xs font-semibold text-gray-700">Scout Talent</p>
            </div>
            <div className="p-3 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
              <Award className="w-8 h-8 text-secondary mx-auto mb-2" />
              <p className="text-xs font-semibold text-gray-700">Make Impact</p>
            </div>
          </div>
          
          <div className="bg-secondary/10 p-4 rounded-lg border border-secondary/20">
            <p className="text-sm text-gray-700">
              <strong>What you'll need:</strong>
              <br />• Passion for helping student-athletes
              <br />• Access to high school programs  
              <br />• Strong evaluation skills
              <br />• Willingness to attend events
            </p>
          </div>
        </div>
        
        <DialogFooter className="flex flex-col sm:flex-row gap-2 pt-2">
          <Button 
            variant="outline" 
            type="button" 
            onClick={() => onOpenChange(false)}
            className="sm:ml-2"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleGoToAdmin}
            className="bg-secondary hover:bg-secondary/90 text-black font-bold"
          >
            Go to Admin Portal
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScoutApplicationModal;